import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: window.sessionStorage.getItem('j_ver')
  },
  mutations: {
    addToken(state, payload) {
      state.token = payload.token;
      window.sessionStorage.setItem('j_ver', payload.token);
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js